var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":""}},[_c('report-header',{attrs:{"title":_vm.headerTitle,"backTo":"false"}}),_c('button-next',{attrs:{"title":_vm.buttonNextTitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }